/**
 * Shared lookups for detail screens.
 * Inputs: trip document + entity id. Outputs: attachments and linked events.
 */

import type { Place, TripDocument, TripEvent } from "@shared/schema.ts";
export { filesFor } from "@shared/files.ts";

export function eventsForBooking(trip: TripDocument, bookingId: string): TripEvent[] {
  return trip.events.filter((event) => event.bookingId === bookingId && !event.archived);
}

export function linkedTransfer(trip: TripDocument, flightId: string): TripEvent | undefined {
  return trip.events.find(
    (event) =>
      !event.archived &&
      event.kind === "transfer" &&
      (event.linkedFlightId === flightId || event.flightId === flightId),
  );
}

export function placeById(trip: TripDocument, id?: string | null): Place | undefined {
  if (!id) return undefined;
  return trip.places.find((place) => place.id === id);
}

export function allergyLines(trip: TripDocument): string[] {
  const lines = new Set<string>();
  for (const booking of trip.bookings) {
    for (const note of booking.dietaryNotes ?? []) lines.add(note);
  }
  return [...lines];
}
